import {Enumify} from "enumify-ts";

class QueryParamType extends Enumify<QueryParamType>() {

    static TEXT = new QueryParamType();
    static DATE = new QueryParamType();
    static _ = QueryParamType._closeEnum();

}

export default QueryParamType;
